import { isNil } from 'lodash';

import { AxisRange } from '@neptune/shared/widgets-domain';

type NonNullableRange = [min: number, max: number];

export function getYAxisRangeWithWholeBins(
  yValues: number[],
  yAxisRange?: AxisRange,
): NonNullableRange {
  const firstYValue = yValues[0];
  const lastYValue = yValues[yValues.length - 1];

  function getMin(yAxisMin: number) {
    if (yAxisMin < firstYValue || yAxisMin > lastYValue) {
      return yAxisMin;
    }

    // closest yValue smaller than given bottom range
    return yValues.findLast((y) => y <= yAxisMin) ?? firstYValue;
  }

  function getMax(yAxisMax: number) {
    if (yAxisMax < firstYValue || yAxisMax > lastYValue) {
      return yAxisMax;
    }

    // closest yValue greater than given top range
    return yValues.find((y) => y >= yAxisMax) ?? lastYValue;
  }

  if (!yAxisRange) {
    return [firstYValue, lastYValue];
  }

  const min = isNil(yAxisRange[0]) ? firstYValue : getMin(yAxisRange[0]);
  const max = isNil(yAxisRange[1]) ? lastYValue : getMax(yAxisRange[1]);

  // conditions below allow rendering proper empty heatmap grid without any tooltip, when the provided range doesn't match given data
  if (min === max) {
    return [min, min + 1];
  }

  if (min > max && isNil(yAxisRange[1])) {
    return [min, min + 1];
  }

  if (min > max && isNil(yAxisRange[0])) {
    return [max - 1, max];
  }

  return [min, max];
}
